var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40Z",
    fill: "#C6A75E",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3352 36.6666C57.0963 40.4021 56.5539 44.2857 54.7982 47.6696C53.0426 51.0536 50.18 53.7334 46.6877 55.2622C43.1954 56.791 39.2845 57.0763 35.6073 56.0706C31.9301 55.0649 28.7088 52.829 26.4806 49.7357C24.2524 46.6424 23.152 42.8787 23.3629 39.0723C23.5738 35.2659 25.0833 31.6468 27.6396 28.8186C30.1959 25.9904 33.6445 24.124 37.4103 23.5307C41.1761 22.9374 45.0315 23.6531 48.3335 25.5583",
    stroke: "#C6A75E",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 38.3334L40 43.3334L56.6667 26.6667",
    stroke: "#C6A75E",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.50c9092bd62f294c68514c11dcdd0d36.svg";
export { ForwardRef as ReactComponent };